import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./theme.css";
import "./index.scss";
import favicon from "./assets/favicon.png";
import App from "./App";
import { ValidUserContextProvider } from "./authCheck";
import Favicon from 'react-favicon';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <ValidUserContextProvider>
      <div>
          <Favicon url={favicon}/>
      </div>
      <App />
    </ValidUserContextProvider>
  </BrowserRouter>
);
